import React from 'react';
import { Button, Card, Flex, Heading, Text } from '@aws-amplify/ui-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Flex justifyContent="center" alignItems="center" padding="2rem">
          <Card variation="elevated" padding="2rem" maxWidth="500px" textAlign="center">
            <Heading level={4}>Something went wrong</Heading>
            <Text marginTop="1rem" marginBottom="1.5rem">
              An unexpected error occurred. Please try again or refresh the page.
            </Text>
            <Flex justifyContent="center" gap="1rem">
              <Button variation="primary" onClick={this.handleRetry}>
                Try Again
              </Button>
              <Button onClick={() => window.location.reload()}>
                Refresh Page
              </Button>
            </Flex>
          </Card>
        </Flex>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
